
<div class="row cpq-scroll">
  <div class="col-md-6">
    <div class="search">
      <cpq-input #availableGroupsInput [label]="{key: labelAvailable.key}" #searchAvailableItems="ngModel" [name]="'searchAvailableItems'" [(ngModel)]='searchKeywordAvailable'
      (ngModelChange)="searchAvailable()" (focusout)="hasAvailableSearchResults=true" [infoMessage]="availableInfoMessage"></cpq-input>
      @if (showSearchIconAvailable) {
        <span class="sap-icon search-icon"></span>
      } @else {
        <span class="sap-icon close-icon" (click)="emptyInputField(false)"></span>
      }
      @if (!hasAvailableSearchResults) {
        <ul class="no-results">
          <li>
            {{'Admin.Msg.NoResultsSearch' | translate}}
          </li>
        </ul>
      }
    </div>
    <div class="title">
      @if (available && available.length > 0) {
        <a class="float-right" (click)="addAllAvailableGroups()"> {{'Admin.SelectList.AddAll' | translate}} </a>
      }
    </div>
    <div class="list multi-select-container cpq-scroll" >
      @if (filteredAvailableItems) {
        <ul class="main-list">
          @for (item of filteredAvailableItems; track item) {
            @if (item.isVisible) {
              <li (click)="addSelected(item)">
                <div class="text-container">
                  {{item.text}}
                  <div class="arrow-container">
                    <span class="sap-icon">&#xe04c;</span>
                  </div>
                </div>
              </li>
            }
          }
        </ul>
      }
    </div>
  </div>
  <div class="col-md-6">
    <div class="search">
      <cpq-input #selectedGroupsInput [label]="{key: labelSelected.key}" #searchSelectedItems="ngModel" [name]="'searchSelectedItems'" [(ngModel)]='searchKeywordSelected'
      (ngModelChange)="searchSelected()" (focusout)="hasSelectedSearchResults=true"></cpq-input>
      @if (showSearchIconSelected) {
        <span class="sap-icon search-icon"></span>
      } @else {
        <span class="sap-icon close-icon" (click)="emptyInputField(true)"></span>
      }
      @if (!hasSelectedSearchResults) {
        <ul class="no-results">
          <li>
            {{'Admin.Msg.NoResultsSearch' | translate}}
          </li>
        </ul>
      }
    </div>
    @if (selected && selected.length > 0) {
      <div class="text-right">
        <a (click)="removeAllSelected()">
          {{'Admin.SelectList.ClearAll' | translate}}
        </a>
      </div>
    }
    <div class="list">
      <ul class="main-list selected-list" [class.selected-list-border]="selected && filteredSelectedItems.length">
        @if (!filteredSelectedItems.length && this.emptySelectedInfoMessage && emptySelectedInfoMessage.key) {
          <li class="msg">
            <div class="alert alert-info">
              <span class="sap-icon">&#xe202;</span>
              <div class="content">
                {{ this.emptySelectedInfoMessage.key | translate}}
              </div>
            </div>
          </li>
        }
        @if (filteredSelectedItems.length) {
          <cdk-virtual-scroll-viewport id="selectedItems" [itemSize]="selectedItemHeight"
            [minBufferPx]="selectedItemsContainerMaxHeight" [maxBufferPx]="selectedItemsContainerMaxHeight"
            [ngStyle]="{'height': filteredSelectedItems.length <= 12 ? filteredSelectedItems.length * selectedItemHeight + 'px' : selectedItemsContainerMaxHeight + 'px'}"
            [ngClass]="{'expanded' : filteredSelectedItems.length}">
            <ng-container *cdkVirtualFor="let item of filteredSelectedItems">
              <li #selectedItem class="selectedItem">
                <div class="flex">
                  <span [attr.title]="item.text">{{item.text}}</span>
                  @if (item.additionalInfo && item.additionalInfo.length > 0) {
                    <span class="sap-icon">&#xe23e;
                      <span>{{item.additionalInfo}}</span></span>
                    }
                    <span class="sap-icon remove-icon" (click)="removeSelectedInteractive(item, selectedItem)"
                    title="{{'Admin.Msg.RemoveButton' | translate}}">&#xe03e;</span>
                  </div>
                </li>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          }
        </ul>
      </div>
    </div>
  </div>
